// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.iScrollVerticalScrollbar.iScrollLoneScrollbar {\r\n  z-index: 1 !important;\r\n  right: 13px !important;\r\n  margin-top: 11px;\r\n  margin-bottom: 11px;\n}\r\n", ""]);
// Exports
module.exports = exports;
